import { notify } from 'utils/reduxUtils';

export const types = {
  CHOOSE_QUOTE: 'modules/quotes/modals/CopyPricingDrawer/CHOOSE_QUOTE',
  OPEN_COPY_PRICING_DRAWER:
    'modules/quotes/modals/CopyPricingDrawer/OPEN_COPY_PRICING_DRAWER',
  OPEN_ASSEMBLY_COPY_PRICING_DRAWER:
    'modules/quotes/modals/CopyPricingDrawer/OPEN_ASSEMBLY_COPY_PRICING_DRAWER',
  CLOSE_COPY_PRICING_DRAWER:
    'modules/quotes/modals/CopyPricingDrawer/CLOSE_COPY_PRICING_DRAWER',
  COPY_PRICING_ERROR:
    'modules/quotes/modals/CopyPricingDrawer/COPY_PRICING_ERROR',
  COPY_PRICING_REQUEST:
    'modules/quotes/modals/CopyPricingDrawer/COPY_PRICING_REQUEST',
  COPY_PRICING_SUCCESS:
    'modules/quote/modals/CopyPricingDrawer/COPY_PRICING_SUCCESS',
  DESELECT_COMPONENT:
    'modules/quotes/modals/CopyPricingDrawer/DESELECT_COMPONENT',
  EXPAND_ASSEMBLY: 'modules/quotes/modals/CopyPricingDrawer/EXPAND_ASSEMBLY',
  GET_ASSEMBLY_COMPONENTS_ERROR:
    'modules/quotes/CopyPricingDrawer/GET_ASSEMBLY_COMPONENTS_ERROR',
  GET_ASSEMBLY_COMPONENTS_REQUEST:
    'modules/quotes/CopyPricingDrawer/GET_ASSEMBLY_COMPONENTS_REQUEST',
  GET_ASSEMBLY_COMPONENTS_SUCCESS:
    'modules/quotes/CopyPricingDrawer/GET_ASSEMBLY_COMPONENTS_SUCCESS',
  GET_DRAFTED_QUOTES_ERROR:
    'modules/quotes/modals/CopyPricingDrawer/GET_DRAFTED_QUOTES_ERROR',
  GET_DRAFTED_QUOTES_REQUEST:
    'modules/quotes/modals/CopyPricingDrawer/GET_DRAFTED_QUOTES_REQUEST',
  GET_DRAFTER_QUOTES_SUCCESS:
    'modules/quotes/modals/CopyPricingDrawer/GET_DRAFTED_QUOTES_SUCCESS',
  GET_ADDITIONAL_QUOTES_ERROR:
    'modules/quotes/CopyPricingDrawer/GET_ADDITIONAL_QUOTES_ERROR',
  GET_ADDITIONAL_QUOTES_REQUEST:
    'modules/quotes/CopyPricingDrawer/GET_ADDITIONAL_QUOTES_REQUEST',
  GET_ADDITIONAL_QUOTES_SUCCESS:
    'modules/quotes/CopyPricingDrawer/GET_ADDITIONAL_QUOTES_SUCEESS',
  GET_QUOTE_ITEMS_ERROR:
    'modules/quotes/modals/CopyPricingModal/GET_QUOTE_ITEMS_ERROR',
  GET_QUOTE_ITEMS_REQUEST:
    'modules/quotes/modals/CopyPricingModal/GET_QUOTE_ITEMS/REQUEST',
  GET_QUOTE_ITEMS_SUCCESS:
    'modules/quotes/modals/CopyPricingModal/GET_QUOTE_ITEMS_SUCCESS',
  INIT_COPY_PRICING_DRAWER:
    'modules/quotes/modals/CopyPricingDrawer/INIT_COPY_PRICING_DRAWER',
  SELECT_COMPONENT: 'modules/quotes/modals/CopyPricingDrawer/SELECT_COMPONENT',
  SET_IS_CHOOSING_QUOTE:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_CHOOSING_QUOTE',
  SET_IS_COPYING_ADD_ONS:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_ADD_ONS',
  SET_IS_COPYING_QUANTITIES:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_QUANTITIES',
  SET_IS_COPYING_MATERIALS:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_MATERIALS',
  SET_IS_COPYING_OPERATIONS:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_OPERATIONS',
  SET_IS_COPYING_PRICING_ITEMS:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_PRICING_ITEMS',
  SET_IS_COPYING_DISCOUNTS:
    'modules/quotes/modals/CopyPricingDrawer/SET_IS_COPYING_DISCOUNTS',
  SET_SELECTED_QUOTE:
    'modules/quotes/modals/CopyPricingDrawer/SET_SELECTED_QUOTE',
};

export const initCopyPricingDrawer = ({
  isSourceItar,
  quote,
  sourceComponent,
  quoteItems,
}) => ({
  type: types.INIT_COPY_PRICING_DRAWER,
  payload: { isSourceItar, quote, sourceComponent, quoteItems },
});

export const copyPricingDrawer = {
  open: ({ sourceComponentId }) => ({
    type: types.OPEN_COPY_PRICING_DRAWER,
    payload: { sourceComponentId },
  }),
  assemblyOpen: () => ({
    type: types.OPEN_ASSEMBLY_COPY_PRICING_DRAWER,
  }),
  close: () => ({
    type: types.CLOSE_COPY_PRICING_DRAWER,
  }),
};

export const setSelectedQuote = ({ selectedQuote }) => ({
  type: types.SET_SELECTED_QUOTE,
  payload: { selectedQuote },
});

export const setIsChoosingQuote = ({ isChoosingQuote }) => ({
  type: types.SET_IS_CHOOSING_QUOTE,
  payload: { isChoosingQuote },
});

export const chooseQuote = () => ({
  type: types.CHOOSE_QUOTE,
});

export const getDraftedQuotes = {
  error: notify(
    (error) => ({
      type: types.GET_DRAFTED_QUOTES_ERROR,
      payload: error,
    }),
    'Error getting drafter quotes',
  ),
  request: () => ({
    type: types.GET_DRAFTED_QUOTES_REQUEST,
  }),
  success: ({ draftedQuotes, hasMoreQuotes }) => ({
    type: types.GET_DRAFTER_QUOTES_SUCCESS,
    payload: { draftedQuotes, hasMoreQuotes },
  }),
};

export const getAssemblyComponents = {
  error: notify(
    (error) => ({
      type: types.GET_ASSEMBLY_COMPONENTS_ERROR,
      payload: error,
    }),
    'Error getting components',
  ),
  request: ({ rootComponentId }) => ({
    type: types.GET_ASSEMBLY_COMPONENTS_REQUEST,
    payload: { rootComponentId },
  }),
  success: ({ rootComponentId, components }) => ({
    type: types.GET_ASSEMBLY_COMPONENTS_SUCCESS,
    payload: { rootComponentId, components },
  }),
};

export const getCurrentQuoteItems = {
  error: notify(
    (error) => ({
      type: types.GET_QUOTE_ITEMS_ERROR,
      payload: error,
    }),
    'Error getting quote items',
  ),
  request: () => ({
    type: types.GET_QUOTE_ITEMS_REQUEST,
  }),
  success: ({ quoteItems }) => ({
    type: types.GET_QUOTE_ITEMS_SUCCESS,
    payload: { quoteItems },
  }),
};

export const expandAssembly = ({ quoteItem }) => ({
  type: types.EXPAND_ASSEMBLY,
  payload: { quoteItem },
});

export const selectComponent = ({ component }) => ({
  type: types.SELECT_COMPONENT,
  payload: { component },
});

export const deselectComponent = ({ component }) => ({
  type: types.DESELECT_COMPONENT,
  payload: { component },
});

export const setIsCopyingMaterials = ({ isCopyingMaterials }) => ({
  type: types.SET_IS_COPYING_MATERIALS,
  payload: { isCopyingMaterials },
});

export const setIsCopyingOperations = ({ isCopyingOperations }) => ({
  type: types.SET_IS_COPYING_OPERATIONS,
  payload: { isCopyingOperations },
});

export const setIsCopyingAddOns = ({ isCopyingAddOns }) => ({
  type: types.SET_IS_COPYING_ADD_ONS,
  payload: { isCopyingAddOns },
});

export const setIsCopyingPricingItems = ({ isCopyingPricingItems }) => ({
  type: types.SET_IS_COPYING_PRICING_ITEMS,
  payload: { isCopyingPricingItems },
});

export const setIsCopyingDiscounts = ({ isCopyingDiscounts }) => ({
  type: types.SET_IS_COPYING_DISCOUNTS,
  payload: { isCopyingDiscounts },
});

export const setIsCopyingQuantities = ({ isCopyingQuantities }) => ({
  type: types.SET_IS_COPYING_QUANTITIES,
  payload: { isCopyingQuantities },
});

export const copyPricing = {
  error: notify(
    (error) => ({
      type: types.COPY_PRICING_ERROR,
      payload: error,
    }),
    'Error copying pricing',
  ),
  request: () => ({
    type: types.COPY_PRICING_REQUEST,
  }),
  success: () => ({
    type: types.COPY_PRICING_SUCCESS,
  }),
};

export const getAdditionalQuotes = {
  error: notify(
    (error) => ({
      type: types.GET_ADDITIONAL_QUOTES_ERROR,
      payload: error,
    }),
    'Error getting additional quotes.',
  ),
  request: () => ({
    type: types.GET_ADDITIONAL_QUOTES_REQUEST,
  }),
  success: ({ quotes, page, hasMoreQuotes }) => ({
    type: types.GET_ADDITIONAL_QUOTES_SUCCESS,
    payload: { quotes, page, hasMoreQuotes },
  }),
};
